// src/components/MinhasTarefasAvaliacao.js
import React, { useState, useEffect } from 'react';
import { db, auth } from '../../firebaseConfig';
import { collectionGroup, query, where, getDocs, doc, getDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { FaUser, FaUsers, FaUserTie, FaSitemap, FaCalendarAlt, FaCheckCircle } from 'react-icons/fa';
import '../../styles/MinhasTarefas.css';

const MinhasTarefasAvaliacao = () => {
    const [tasks, setTasks] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const currentUser = auth.currentUser;

    useEffect(() => {
        if (!currentUser) {
            setLoading(false);
            return;
        }

        const fetchTasks = async () => {
            setLoading(true);
            try {
                // Passo 1: Buscar o documento do usuário atual para obter o empresa_id
                const userDocRef = doc(db, 'users', currentUser.uid);
                const userDocSnap = await getDoc(userDocRef);

                if (!userDocSnap.exists() || !userDocSnap.data().empresa_id) {
                    console.error("Não foi possível encontrar o ID da empresa para o usuário logado.");
                    setLoading(false);
                    return;
                }
                const userEmpresaId = userDocSnap.data().empresa_id;

                // Passo 2: Usar o empresa_id para filtrar a collectionGroup
                const responsesRef = collectionGroup(db, 'responses');
                const q = query(responsesRef, 
                    where('evaluatorUserId', '==', currentUser.uid),
                    where('empresaId', '==', userEmpresaId), // <-- FILTRO ADICIONADO AQUI
                    where('status', '==', 'pending')
                );
                
                const querySnapshot = await getDocs(q);
                
                const tasksPromises = querySnapshot.docs.map(async (responseDoc) => {
                    const responseData = responseDoc.data();
                    const cycleDocRef = responseDoc.ref.parent.parent;
                    
                    if (cycleDocRef) {
                        const evaluatedUserDocRef = doc(db, 'users', responseData.evaluatedUserId);
                        
                        const [cycleSnap, evaluatedUserSnap] = await Promise.all([
                            getDoc(cycleDocRef),
                            getDoc(evaluatedUserDocRef)
                        ]);

                        if (cycleSnap.exists() && evaluatedUserSnap.exists()) {
                            return {
                                id: responseDoc.id,
                                path: responseDoc.ref.path,
                                ...responseData,
                                cycle: cycleSnap.data(),
                                evaluatedUser: evaluatedUserSnap.data(),
                            };
                        }
                    }
                    return null;
                });
                
                const tasksData = (await Promise.all(tasksPromises)).filter(Boolean);
                setTasks(tasksData);

            } catch (error) {
                console.error("Erro ao buscar tarefas de avaliação:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchTasks();
    }, [currentUser]);

    const getRelationshipInfo = (relationship) => {
        switch (relationship) {
            case 'self': return { icon: <FaUser />, text: 'Sua autoavaliação' };
            case 'manager': return { icon: <FaUserTie />, text: 'Avaliar seu gestor:' };
            case 'peer': return { icon: <FaUsers />, text: 'Avaliar seu par:' };
            case 'direct_report': return { icon: <FaSitemap />, text: 'Avaliar seu liderado:' };
            default: return { icon: <FaUser />, text: 'Avaliar:' };
        }
    };

    if (loading) return <div className="tasks-container"><p>Carregando suas tarefas...</p></div>;

    return (
        <div className="tasks-container">
            <h2><i className="fas fa-clipboard-list" style={{ color: '#000000ff' }}></i> Minhas Avaliações Pendentes</h2>

            {tasks.length > 0 ? (
                <div className="tasks-grid">
                    {tasks.map(task => {
                        const { icon, text } = getRelationshipInfo(task.relationship);
                        const deadline = task.cycle?.endDate?.toDate();

                        return (
                            <div key={task.id} className="task-card">
                                <div className="task-card-header">
                                    <h3>{task.cycle?.name}</h3>
                                </div>
                                <div className="task-card-body">
                                    <div className="evaluated-user-info">
                                        {task.evaluatedUser?.photoURL ? 
                                            <img src={task.evaluatedUser.photoURL} alt={task.evaluatedUser.name} /> : 
                                            <FaUser size={50} style={{ borderRadius: '50%', background: '#e9ecef', padding: '10px' }} />
                                        }
                                        <div className="info">
                                            <p>{text}</p>
                                            <h4>{task.evaluatedUser?.name}</h4>
                                        </div>
                                    </div>
                                    <div className="task-details">
                                        {deadline && (
                                            <p><FaCalendarAlt /> <strong>Prazo:</strong> {deadline.toLocaleDateString('pt-BR')}</p>
                                        )}
                                    </div>
                                </div>
                                <div className="task-card-footer">
                                    <button onClick={() => navigate(`/avaliacoes/responder/${task.id}`, { state: { responsePath: task.path } })} className="btn btn-primary">
                                        Responder Agora
                                    </button>
                                </div>
                            </div>
                        )
                    })}
                </div>
            ) : (
                <div className="tasks-empty">
                    <FaCheckCircle />
                    <h3>Tudo em dia!</h3>
                    <p>Você não possui nenhuma avaliação pendente no momento.</p>
                </div>
            )}
        </div>
    );
};

export default MinhasTarefasAvaliacao;